import { render, staticRenderFns } from "./CxCategory.vue?vue&type=template&id=2786e9a3&"
import script from "./CxCategory.vue?vue&type=script&lang=js&"
export * from "./CxCategory.vue?vue&type=script&lang=js&"
import style0 from "./CxCategory.vue?vue&type=style&index=0&id=2786e9a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports